// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ac1bbe92","110":"554a03a2","135":"0833502c","345":"929ecb41","497":"e4f05ace","611":"f9bc46c5","787":"149a7545","857":"05ee0852","976":"8ddae6c1"}[chunkId] + ".chunk.js";
};